var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMmusicLogoBordered(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2283_5809)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 1,
    width: 48,
    height: 48,
    rx: 10,
    fill: "#0061FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.3684 22.3924L38.2274 21.1561C36.4198 20.1106 34.1255 20.4853 32.7444 22.0519C32.6896 22.1129 32.6348 22.1762 32.5845 22.2412L31.7873 23.2503V18.9399C31.7873 18.0115 31.2921 17.154 30.4877 16.6899L26.0921 14.1501C24.2988 13.1156 22.0175 13.5553 20.7373 15.1825L19.8224 16.3453V12.0308C19.8214 11.1034 19.3261 10.2469 18.5228 9.78322L16.2431 8.46881C14.5714 7.5038 12.4335 8.0763 11.4682 9.74797C11.1609 10.2801 10.9993 10.8841 11 11.4987V39.5061C11.0003 41.4361 12.5656 43.0003 14.4961 43C15.1095 43 15.7119 42.8385 16.2431 42.5319L18.5231 41.2178C19.3244 40.7562 19.8197 39.903 19.8228 38.9784V28.0741L20.8322 25.9421L22.967 21.4278V36.853C22.9793 37.4334 23.4599 37.8943 24.0404 37.882C24.2112 37.8786 24.3782 37.8334 24.5275 37.7506L31.2701 33.8607C31.5898 33.6722 31.7863 33.3296 31.7877 32.9587V30.9886L34.9234 24.4032L34.936 24.38V29.9374C34.9343 30.5109 35.3978 30.9777 35.9714 30.9794C36.1542 30.9801 36.3339 30.9325 36.4921 30.8415L40.3681 28.6041C42.0853 27.6134 42.6744 25.4182 41.6832 23.7014C41.3679 23.1552 40.9144 22.7018 40.3681 22.3866V22.3928L40.3684 22.3924Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9675 19.0038C22.9675 15.6543 21.3964 15.0928 20.4291 15.5787C20.0296 16.0581 19.8232 16.3483 19.8232 16.3483V28.077L22.9675 21.4283V19.0038Z",
    fill: "#CED9EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.7445 22.0516C34.5658 21.6899 34.877 23.431 34.9235 24.4002L31.7878 30.9879V23.25L32.7449 22.0516H32.7445Z",
    fill: "#CED9EA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2283_5809",
    x: 0,
    y: 0,
    width: 52,
    height: 52,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2283_5809"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2283_5809",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMmusicLogoBordered);
export default __webpack_public_path__ + "static/media/mmusic-logo-bordered.d46fc1336f8e00c3bcfb05bf1ce7715e.svg";
export { ForwardRef as ReactComponent };